import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsLeftCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M3.5 8l4-4v2h4v4h-4v2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsLeftCircle
